import * as React from 'react';

export const InformationIcon = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M49.0111 47.1447C48.3947 46.7857 44.6417 44.4616 42.6337 40.2595C47.3234 35.8743 49.9908 29.774 49.9908 23.5309C49.9908 10.61 38.7243 0 24.9954 0C11.2665 0 0 10.61 0 23.5309C0 36.4518 11.2665 47.0617 24.9954 47.0617C26.8384 47.0617 28.818 46.889 31.5492 46.3151C38.7277 50.1296 45.1709 50.0224 47.6224 49.9837C48.7137 49.9701 49.5059 50.1672 49.9137 49.0397C50.1896 48.2835 49.7814 47.41 49.0111 47.1447ZM27.9246 35.3451C27.9246 36.9627 26.6132 38.2743 24.9954 38.2743C23.3776 38.2743 22.0662 36.9627 22.0662 35.3451V23.5309C22.0662 21.9131 23.3776 20.6017 24.9954 20.6017C26.6132 20.6017 27.9246 21.9131 27.9246 23.5309V35.3451ZM24.9954 16.1103C23.3776 16.1103 22.0662 14.7987 22.0662 13.1811C22.0662 11.5634 23.3776 10.252 24.9954 10.252C26.6132 10.252 27.9246 11.5634 27.9246 13.1811C27.9246 14.7988 26.6132 16.1103 24.9954 16.1103Z"
      fill="#60C718"
    />
  </svg>
);
